import PlainCalendar, { type PlainCalendarProps } from './plain-calendar'
import { PlainCalendarDouble, PlainCalendarDoubleProps } from './plain-calendar-double'
import useDaysSelectedState from './use-days-slected-state'
// import { dateFormat as dateFormatDefault } from './date-format'


export default PlainCalendar
export { useDaysSelectedState, PlainCalendarDouble }
export type { PlainCalendarProps, PlainCalendarDoubleProps }
